<section>
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div class="exhibitorhighlight">
          <div class="exhibitorhighlight__details">
            <div class="exhibitorhighlight__logowrapper">
              @if (exhibitor?.logo?.provider) {
              <img
                [src]="
                  exhibitor?.logo?.resource
                    | ImageUrl : exhibitor?.logo?.provider : { width: 60, height: 60, fileType: ImageFileTypes.WEBP }
                "
                [alt]="exhibitor?.name"
                class="exhibitorhighlight__logo" />
              } @else {
              <mat-icon class="exhibitorhighlight__logo-placeholder">corporate_fare</mat-icon>
              }
            </div>
            <div class="exhibitorhighlight__content">
              @if (size !== 'phone') {
              <span class="exhibitorhighlight__subtext" i18n="@@featureProductDetails-productBy"
                >Ist ein Produkt von</span
              >
              <a
                [routerLink]="exhibitorClickable ? ['/fairs', exhibitor?.fair_id, 'exhibitors', exhibitor?.id] : []"
                class="exhibitorhighlight__link">
                {{ exhibitor?.name }}
              </a>
              <bau365-channel-subscribe-button
                [entityId]="product?.exhibitor_id"
                [fairId]="product?.fair_id"
                [context]="'product-details'"></bau365-channel-subscribe-button>
              } @else { @if (hallPlanToggle$ | async) { @if (product?.exhibition_halls) {
              <planone-location
                [exhibition_halls]="product?.exhibition_halls"
                [fair_id]="exhibitor?.fair_id"
                [locationClickable]="locationClickable"></planone-location>
              } } }
            </div>
          </div>
          @if (size !== 'phone') { @if (product?.exhibition_halls && (hallPlanToggle$ | async)) {
          <div class="exhibitorhighlight__location">
            @if (product?.exhibition_halls) {
            <planone-location
              [exhibition_halls]="product?.exhibition_halls"
              [fair_id]="exhibitor?.fair_id"
              [locationClickable]="locationClickable"></planone-location>
            }
          </div>
          } } @else {
          <div class="exhibitorhighlight__mobilecontent">
            <span class="exhibitorhighlight__subtext" i18n="@@featureProductDetails-productBy"
              >Ist ein Produkt von</span
            >
            <a
              [routerLink]="['/fairs', exhibitor?.fair_id, 'exhibitors', exhibitor?.id]"
              class="exhibitorhighlight__link">
              {{ exhibitor?.name }}
            </a>
            <bau365-channel-subscribe-button
              [entityId]="product?.exhibitor_id"
              [fairId]="product?.fair_id"
              [context]="'product-details'"></bau365-channel-subscribe-button>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
